// @NOTE: assumes jQuery is included by WP
import $ from 'jquery';

import Swiper from 'swiper/bundle';

class general {
  constructor () {
    this.$window = $(window)

    //home slider
    if ($('.hero-slider-wrapper .swiper-container .swiper-slide').length > 1) {
      var homeswiper = new Swiper ('.hero-slider', {
        fadeEffect: { crossFade: true },
        direction: 'horizontal',
        loop: true,
        effect: 'fade',
        speed: 1500,
        slidersPerView: 1,
        updateOnWindowResize: true,
        autoplayDisableOnInteraction: false,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          loop: true,
        },

        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },

        autoplay: {
          delay: 3000,
          // disableOnInteraction: false,
        },

      });
    }

    //project details slider
    if ($('.project-gallery .swiper-container .swiper-slide').length > 1) {
      var swiper = new Swiper(".gallery-thumbs", {
        loop: false,
        spaceBetween: 30,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
      });
      
      var swiper2 = new Swiper(".gallery-top", {
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: swiper,
        },
      });
    }

    //custom tabs
    $('.tab-menu li a').on('click', function(){
      var target = $(this).attr('data-rel');
      $('.tab-menu li a').removeClass('active');
      $(this).addClass('active');
      $("#"+target).fadeIn('slow').siblings(".tab-box").hide();
      return false;
    });

    //Scroll to tab on page load
    var hash = location.hash;
    if (hash !== '' && $('.about-tabs li a[href$="'+hash+'"]').length) {
      $('.about-tabs li a[href$="'+hash+'"]').trigger('click');
    }

    var mobihash = location.hash;
    if (mobihash !== '' && $('.about_tab_drawer_heading[href$="'+mobihash+'"]').length) {
      $('.about_tab_drawer_heading[href$="'+mobihash+'"]').trigger('click');
    }

    var resizeTimer;
    $(window).on('resize', function(e) {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        //tabControl();
      }, 250);
    });
    

  function isMobileView() {
    return $(window).width() <= 767; // Adjust the width value as per your mobile breakpoint
  }
  //about
  /* if in tab mode */
  $(".about-tabs li a").click(function() {
    event.preventDefault();
    event.stopPropagation();
    var target = $(this).attr('href'),
    tabs = $(this).parents('.tabs'),
    buttons = tabs.find('a'),
    item = tabs.parents('.tabbed-content').find('.item');
    var pos = $(window).scrollTop();
    window.location.hash = target;
    $(window).scrollTop(pos);
    var nearestItem = $(this).closest('.about-item')
    $(".item").hide();
    var activeTab = $(this).attr("rel"); 
    $("#"+activeTab).fadeIn();    
  
    $(".about-tabs li a").removeClass("active");
    $(this).addClass("active");

    $(".about_tab_drawer_heading").removeClass("active");
    $(".about_tab_drawer_heading[rel^='"+activeTab+"']").addClass("active");
    // Update the URL with the hash corresponding to the clicked tab
    window.location.hash = activeTab;

  });

  /* if in drawer mode */
  $(".about_tab_drawer_heading").click(function() {
    event.preventDefault();
    event.stopPropagation();
    var nearestItem = $(this).closest('.about-item')
    $(".item").hide();
    var d_activeTab = $(this).attr("rel"); 
    $("#"+d_activeTab).fadeIn();
    $(".about_tab_drawer_heading").removeClass("active");
    $(this).addClass("active");
    $(".about-tabs li a").removeClass("active");
    $(".about-tabs li a[rel^='"+d_activeTab+"']").addClass("active");
    // Update the URL with the hash corresponding to the clicked tab
    window.location.hash = d_activeTab;
    var scrollTop = $(nearestItem).position().top;
    $('html, body').stop().animate({ scrollTop });

  });

  $(".item").hide();
  $(".item:first").show();

  // Check if there is a hash in the URL and show the corresponding tab on page load
  if (window.location.hash) {
      var hash = window.location.hash.substr(1);
      var activeTab = $("a[rel='" + hash + "']");
      if (activeTab.length) {
        var nearestItem = activeTab.closest('.about-item')
        $(".item").hide();
        $("#" + hash).fadeIn();

        $(".about-tabs li a").removeClass("active");
        activeTab.addClass("active");

        $(".about_tab_drawer_heading").removeClass("active");
        $(".about_tab_drawer_heading[rel^='" + hash + "']").addClass("active");
      }
  }

  $(".tab_content").hide();
  $(".tab_content:first").show();




  //team
  /* if in tab mode */
  $("ul.tabs li").click(function() {
    $(".tab_content").hide();
    var activeTab = $(this).attr("rel"); 
    $("#"+activeTab).fadeIn();    
  
    $("ul.tabs li").removeClass("active");
    $(this).addClass("active");

    $(".tab_drawer_heading").removeClass("d_active");
    $(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
  });
  /* if in drawer mode */
  $(".tab_drawer_heading").click(function() {
    $(".tab_content").hide();
    var d_activeTab = $(this).attr("rel");
    var nearestItem = $(this).next();
    $("#"+d_activeTab).fadeIn();
    $(".tab_drawer_heading").removeClass("d_active");
    $(this).addClass("d_active");
    $("ul.tabs li").removeClass("active");
    $("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
    var scrollTop = $(nearestItem).position().top;
    $('html, body').stop().animate({ scrollTop });
  });
  
  $('ul.tabs li').last().addClass("tab_last");
  
  }
}

export default general


// WEBPACK FOOTER //
// ./src/js/shg/general/general.js